import axios from 'axios';

export const axiosClients = {
    rest: {
        client: axios.create({
            responseType: 'json',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },
    api: {
        client: axios.create({
            baseURL: '/api',
            responseType: 'json',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },
    auth: {
        client: axios.create({
            baseURL: '/api/auth',
            responseType: 'json',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },
    apiMultipart: {
        client: axios.create({
            baseURL: '/api',
            responseType: 'json',
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    empty: {
        client: axios.create({
            baseURL: '',
            responseType: 'json',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }
};

